import { FC, useEffect, useState } from 'react';
import { VerifyOtpProps } from './verifyOtp.type';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import { renderDesktopView, renderTabletView } from './verifyOtpHelper';
import { useLocation, useNavigate } from 'react-router-dom';
import { route } from '../../service/router';
import { OTPLength, StorageKey } from '../../utils/helper.type';
import { useLoginData, useOtpVerify } from '../../hooks/useAuthData';

const VerifyOtp: FC<VerifyOtpProps> = () => {
  const location = useLocation();
  const { email, password } = location.state || {};

  const { isDesktop } = useResponsiveLayout();

  const [otp, setOtp] = useState<string>('');
  const { verifyOtp, isVerifyLoading, error, setError } = useOtpVerify();
  const { login, isLoading } = useLoginData();

  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate(route.login);
  };

  const handleOtpVerify = async () => {
    if (isVerifyLoading) {
      console.log('[VerifyOtp] Already in progress... skipping this request');
      return;
    }

    try {
      console.log(`[ENTRY][VerifyOtp....]`);
      const sessionId: string = localStorage.getItem(StorageKey.SESSION_ID)!;
      console.log(`[VerifyOtp][SessionId]...`, sessionId);
      if (sessionId) {
        await verifyOtp(email, sessionId, otp);
        console.log('[VerifyOtp] Verification successful');
      } else {
        console.warn('[VerifyOtp] No sessionId found in localStorage');
      }
    } catch (error) {
      console.error('[VerifyOtp] Verification failed:', error);
    } finally {
      console.warn('[VerifyOtp] finally block...');
    }
  };

  useEffect(() => {
    if (otp.length === 6) {
      handleOtpVerify();
    }
  }, [otp]);

  const handleResendClick = async () => {
    setOtp('');
    setError('');
    await login(email, password);
  };

  return (
    <div className="relative min-h-screen w-full">
      {isDesktop
        ? renderDesktopView(
            otp,
            setOtp,
            handleBackToLogin,
            email,
            error,
            isVerifyLoading || isLoading,
            handleResendClick,
          )
        : renderTabletView(
            handleResendClick,
            otp,
            setOtp,
            OTPLength,
            handleBackToLogin,
            'resendOtp',
            error,
            handleOtpVerify,
            isVerifyLoading || isLoading,
            email,
          )}
    </div>
  );
};

export default VerifyOtp;
